/* global console */
/* global define */
define('analytics/datalayer',[
    'jquery',
    'underscore',
    'pubsub',
    'fwinfo',
    'utils',
    'managers/routemanager',
    'user-manager',
    'state'
],
function(
    $,
    _,
    PubSub,
    FwInfo,
    Utils,
    RouteManager,
    UserManager,
    StateManager
) {
    'use strict';
    var _curPage = {},
        _queue = [];

    function _gciAnalytics(method, data) {
        if (_queue) {
            _queue.push([method, data]);
        } else {
            gciAnalyticsTrack(method, data);
        }
    }

    function gciAnalyticsTrack(type, data) {
        if (type === 'view') {
            window.gciAnalytics.view(data);
        } else {
            window.gciAnalytics.link(data);
        }
    }

    var SetDataLayer = function() {
        if (window.tealium_url && (window.tealium_url.indexOf('/standard/') !== -1 || window.tealium_url.indexOf('/gciAnalytics.js') !== -1 || window.tealium_url.indexOf('/dcjs/') !== -1)){
            this.initialize();
        }
    };

    SetDataLayer.prototype = {
        initialize: function() {
            var ie11 = !!window.MSInputMethodContext && !!document.documentMode;
            this.data = {};

            this.pubSub = {
                'analytics:pageload:tealium': this.page_load,
                'heattrack': this.heattrack,
                'slide:change': this.slide_change,
                'user:logout': this.clear_user_data,
                'uotrack': this.uotrack,
                'video:load': this.video_load,
                'track': this.track,
                'vitrack': this.vitrack,
                'newslettertrack': this.newslettertrack,
                'userUtil:personal_link': this.user_util_personal_link,
                'advertising:loaded': this.load_script

                //'group_page_view': this.group_page_view,
                //'product_name': this.product_name
            };
            PubSub.attach(this.pubSub, this);

            this.hashRegExp = /\bht=([^&]*)/;
            this.cspRegExp = /[?&]csp=([^&]*)/i;
            this.gcionidRegExp = /\bGCIONID=([^;]*)/;
            this.daysArr = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

            document.addEventListener('gciAnalyticsReady', function(e) {
                _.each(_queue, function(item) {
                    gciAnalyticsTrack(item[0], item[1]);
                });
                _queue = null;
            });

            // We are looking for browsers other than IE11 here
            if(!ie11) {
                this.load_script();
            }
        },
        load_script: function() {
            Utils.loadScript(window.tealium_url, 'gciAnalytics').done(function(gciAnalytics) {}).fail(_.bind(function() {
                this.destroy();
            }, this));
            PubSub.unattach({'advertising:loaded': this.load_script}, this);
        },
        ready: function() {
            // needed until we transition ourselves out of the old callback hack we used which has now been replaced by Utils.loadScript
        },
        destroy: function() {
            PubSub.unattach(this.pubSub, this);
        },

        /**
         * @param {Object} detail
         * @param {String} eventType
         * @returns {Object}
         */
        get_page_data: function(detail, eventType) {
            var cstList = this._getCstList(detail.cst),
                sstsList = this._getSstsList(detail.ssts),
                hashValue = this._getHashValue(),
                pageUser = detail.user || {},
                pagePrevPage = detail.prevPageInfo || {},
                contributorNames,
                contributorIds,
                fireflyAkamaiCookie = this._getCookie('firefly_akamai'),
                pageDebugger,
                clientHasAdBlocker = this._getCookie('__adblocker');

            this.clickName = hashValue || FwInfo.getandclearsessionvalue('clickName');
            this.clickPage = FwInfo.getandclearsessionvalue('clickPage');

            try {
                if (typeof window.atob === 'function' && fireflyAkamaiCookie) {
                    // returns an object:
                    // {""epochExpirationTimestamp"": 1521125684,
                    //  ""userType"": ""Registered"",
                    //  ""lastModifiedTimestamp"": 1520260292,
                    //  ""atyponId"": 26127592}
                    var d = JSON.parse(window.atob(fireflyAkamaiCookie.replace(/""/g, '').split('|')[0].toString())); // returns an object
                    pageDebugger = [d.userType, d.atyponId].join('|'); // ""Registered|26127592""
                }
            } catch(e) {
                pageDebugger = 'JSException';
            }

            // adjust contenttype for first slide in a cinematic gallery to match every subsequent slide change
            if (detail.basePageType === 'gallery-cinematic' && detail.contenttype === 'videopage') {
                detail.contenttype = 'videopage gallery';
            }

            try {
                contributorNames = _.map(detail.contributors, function(obj){ return obj.DisplayName; }).join(',');
            } catch (e){}

            try {
                contributorIds = _.map(detail.contributors, function(obj){ return obj.Id; }).join(',');
            } catch (e){}

            return {

                'client-action': this.clickName,
                'client-has-ad-blocker': clientHasAdBlocker,
                'client-time-of-day': this._getTimeOfDay(),
                'client-time-of-day-and-day-of-week': this._getTimeOfDay() + '|' + this._getDayOfWeek(),

                'content-byline': detail.byline || '',
                'content-contributor-names': contributorNames || '',
                'content-contributor-ids': contributorIds || '',
                'content-cst-category': cstList[0],
                'content-cst-subcategory': cstList.slice(0,2).join(':'),
                'content-cst-topic': cstList.slice(0,3).join(':'),
                'content-date-published': detail.published_date || '',
                'content-headline': detail.headline || '',
                'content-id': detail.assetid,
                'content-name': detail.routePath.split('?')[0] || '',
                'content-photo-gallery-name': detail.gallerytitle || '',
                'content-photo-gallery-index': detail.galleryindex || '',
                'content-protection-state': detail.content_protection_state || '',
                'content-sponsor-name': detail.sponsorname || '',
                'content-ssts-section': sstsList[0],
                'content-ssts-subsection': sstsList.slice(0,2).join(':'),
                'content-ssts-topic': sstsList.slice(0,3).join(':'),
                'content-ssts-subtopic': sstsList.slice(0,4).join(':'),
                'content-source': StateManager.getActivePageInfo().origin,
                'content-title': document.title,
                'content-type': detail.contenttype,
                'content-video-duration': "",
                'content-video-provider' : "",
                'content-video-name': "",
                'content-video-player-type' : "",
                'content-keywords': detail.taxonomykeywords,

                'event-application-variants': detail.applicationVariant || '',
                'event-type': eventType,
                'event-paywall-state': (function (detail) {
                    var contentName = window.location.pathname,
                        eventPaywallState = '',
                        paywallType = 'iframe';

                    if (detail.roadblock_needed) {
                        paywallType = 'inline';
                        if (detail.content_tier == 'metered') {
                            eventPaywallState = 'metered';
                        } else {
                            eventPaywallState = 'premium';
                        }
                    }

                    if (contentName.indexOf('restricted') > -1) {
                        eventPaywallState = 'premium';
                    } else if (contentName.indexOf('get-access') > -1) {
                        eventPaywallState = 'metered';
                    }

                    if (eventPaywallState.length > 0) {
                        eventPaywallState = paywallType + '_' + eventPaywallState + '_roadblock';
                    }

                    return eventPaywallState;
                })(detail),

                'page-has-video': detail.videoincluded || "no",
                'page-domain': window.location.hostname,
                'page-debugger': pageDebugger,
                'page-experience-type': "desktop",
                'page-full-url': document.location.href,
                'page-oembed': this._getOembedData(detail.js_modules, detail.assetid) || '',
                'page-on-site-search': detail.searchkeywords || '',
                'page-percent-viewed': FwInfo.getandclearsessionvalue('percentagePageViewed'),
                'page-previous-content-name': FwInfo.getandclearsessionvalue('prevpath'),
                'page-previous-full-url': FwInfo.getandclearsessionvalue('prevurl'),
                'page-refreshed': detail.refreshed || '',

                'page-ab-slot': Utils.getNested(pageUser, 'abTestSlot'),
                'page-ab-variant': Utils.getNested(pageUser, 'abTest', 'userVariant', 'id'),
                'page-ab-prev-variant': Utils.getNested(pagePrevPage, 'user', 'abTest', 'userVariant', 'id')
            };
        },

        clear_user_data: function() {
            _setDataLayer.data = {};
        },

        get_user: function () {
            var dfd = $.Deferred();

            if (UserManager.accounts.firefly) {
                UserManager.accounts.firefly.getUserResponse().always(function(userInfo){
                    if (typeof userInfo === 'object') {
                        if (typeof window.gciAnalytics === 'undefined') {
                            window.gciAnalytics = {};
                        }
                        window.gciAnalytics.user = userInfo;
                    }
                    dfd.resolve(userInfo);
               });
           } else {
               dfd.resolve({});
           }
           return dfd.promise();
        },

        /**
         * @param {Object} detail
         *      @param {Object} detail.prevPvParams - Params from the previous page view.
         */
        page_load: function(detail) {
            var data;

            if(!detail.noinitialanalytics) {
                var gciData = _setDataLayer.get_page_data(detail, 'page:load');
                _curPage = gciData;

                FwInfo.setsessionvalue('prevpath', document.location.pathname);
                FwInfo.setsessionvalue('prevurl', document.location.href);

                this.get_user().always(function(user){
                    var userMeterDuration;

                    try {
                        var fireflyGeneralCookie = this._getCookie('firefly_general');
                        if (fireflyGeneralCookie) {
                            userMeterDuration = JSON.parse(atob(fireflyGeneralCookie.replace(/^"(.*)"$/, '$1'))).epochDuration / 86400;
                        }
                    } catch (err) {
                        userMeterDuration = 'unsupported';
                    }
                    gciData['user-meter-duration'] = userMeterDuration;

                    _gciAnalytics('view', gciData);
                });
            }
        },
        track: function(options) {
            options = options || {};
            var url = options.url,
                label = this._getLabel(options.event, options.label);
            this.setPageDepth();
            if (url && RouteManager.getInfo(url)) {
                // internal tracking
                this.heattrack(label);
            } else if (label) {
                //TODO have uotrack send the href, then we can remove the requirement of having a label for uotracking
                // external tracking
                this.uotrack(label);
            }
        },
        setPageDepth: function() {
            var percentagePageViewed = Math.floor(((Utils.getScrollPosition() + window.innerHeight) /
                document.body.clientHeight) * 100);
            FwInfo.setsessionvalue('percentagePageViewed', percentagePageViewed);
        },
        _getLabel: function(event, defaultLabel) {
            if (event) {
                var dom = $(event.currentTarget);
                return dom.data('trackLabel') || dom.data('uotrack') || dom.data('ht') || defaultLabel;
            }
            return defaultLabel;
        },
        _getCookie: function(name) {
            return $.cookie(name);
        },
        uotrack: function(detail) {
            if (typeof detail !== 'string') {
                console.error('uotrack has been given a non-string event argument', detail);
                detail = (detail||{}).prop41 || 'somethingbad';
            }
            var vars = detail.match(/{% *[a-z0-9_]* *%}/gi);
            if (vars) {
                for (var j = 0; j < vars.length; j++) {
                    var v = vars[j];
                    var name = v.match(/{% *([a-z0-9_]*) *%}/) && RegExp.$1;
                    detail = detail.replace(v, _curPage[name]);
                }
            }

            _gciAnalytics('link', {
                'client-action': detail,
                'page-previous-full-url': location.href,
                'event-type': 'uotrack'
                //linkTrackEvents: 'None',
                //linkTrackVars: 'prop41,prop64'
            });
        },
        vitrack: function(detail) {
            if (typeof detail !== 'object') {
                console.error('vitrack has been given a non-object event argument', detail);
                detail = (detail||{}).prop9 || 'somethingbad';
            }
            _gciAnalytics('link', {
                milestonetrack: detail.percentage,
                'event-type': 'vitrack',
                //linkTrackEvents: 'None',
                //linkTrackVars: 'prop9',
                video_url: detail.video_url
            });
        },
        /*
        group_page_view: function(detail) {
            _gciAnalytics('link', {
                group_page: detail,
                'event-type': 'group_page_view',
                linkTrackEvents: 'None',
                linkTrackVars: 'eVar99'
            });
        },
        */
        /*
        product_name: function(detail) {
            _gciAnalytics('link', {
                product_name: detail,
                'event-type': 'product_name',
                linkTrackEvents: 'None',
                linkTrackVars: 'eVar66'
            });
        },
        */

        user_util_personal_link: function(detail) {
            _gciAnalytics('link', {
                'user-personalized-link-id': detail,
                'event-type': 'gup-personal-link',
                linkTrackEvents: 'None',
                linkTrackVars: 'eVar63'
            });
        },
        newslettertrack: function(fbid) {
            _gciAnalytics('newsltr-signup', {
                fbid: fbid
            });
        },
        heattrack: function(clickName) {
            if (clickName) {
                clickName = clickName;
                FwInfo.setsessionvalue('clickName', clickName);
            }
            FwInfo.setsessionvalue('clickPage', location.href);
        },
        slide_change: function(detail) {
            var cstList, sstsList;
            try {
                cstList = detail.cst.split('/');
                sstsList = detail.ssts.split('/');
            } catch (er) {
                console.error('Invalid page', er.stack || er.stacktrace || er.message);
                return;
            }
            _gciAnalytics('view', _.extend(_curPage, {
                'client-action': FwInfo.getandclearsessionvalue('clickName'),
                'content-byline': detail.byline || "",
                'content-cst-category': cstList[0],
                'content-cst-subcategory': cstList.slice(0,2).join(':'),
                'content-cst-topic': cstList.slice(0,3).join(':'),
                'content-date-published': detail.publishedDate || '',
                'content-id': detail.gallery_id,
                'content-keywords':  "",
                'content-name': detail.pathName || '',
                'content-photo-gallery-name': detail.gallery_title,
                'content-photo-gallery-index': detail.gallery_index,
                'content-ssts-section': sstsList[0],
                'content-ssts-subsection': sstsList.slice(0,2).join(':'),
                'content-ssts-topic': sstsList.slice(0,3).join(':'),
                'content-ssts-subtopic': sstsList.slice(0,4).join(':'),
                'content-type': detail.contenttype,
                //viralVideoDomain: "",
                'content-video-provider': "",
                //videoFulllengthUrl: "",
                'content-video-name': "",
                'content-video-duration': "",
                'content-video-player-type': "",
                //milestonetrack: "",
                //videotranscript: ""
                'event-type': 'slide:change',
                'page-full-url': window.location.href,
                'page-previous-full-url': window.location.protocol + '//' + window.location.host + detail.pathName,
                'page-has-video': detail.videoincluded || "no",
            }));
        },
        video_load: function(detail) {
            var cstList, sstsList;
            try {
                cstList = detail.cst.split('/');
                sstsList = detail.ssts.split('/');
            } catch (er) {
                console.error('Invalid page', er.stack || er.stacktrace || er.message);
                return;
            }
            _gciAnalytics('view', _.extend(_curPage, {
                'content-byline': detail.byline || '',
                'client-action': this._getHashValue() || FwInfo.getandclearsessionvalue('clickName'),
                'page-previous-full-url': FwInfo.getandclearsessionvalue('clickPage'),
                'content-cst-category': cstList[0],
                'content-cst-subcategory': cstList.slice(0,2).join(':'),
                'content-cst-topic': cstList.slice(0,3).join(':'),
                'content-id': detail.assetid || '',
                'content-date-published': detail.publishedDate || '',
                'content-ssts-section': sstsList[0],
                'content-ssts-subsection': sstsList.slice(0,2).join(':'),
                'content-ssts-topic': sstsList.slice(0,3).join(':'),
                'content-ssts-subtopic': sstsList.slice(0,4).join(':'),
                'content-video-player-type': detail.videoplayername || '',
                //prevpath: FwInfo.getandclearsessionvalue('prevpath'),
                //completion: detail.completion || '',
                'content-keywords': detail.keywords || '',
                'content-type': detail.contenttype || '',
                'content-video-name': detail.videoName || '',
                'content-video-duration': detail.videoDuration || '',
                'event-type': detail.eventtype || '',
                'content-name': detail.pathName || '',
                //videoContentID: detail.contentid || '',
                //viralVideoDomain: detail.viralVideoDomain || '',
                'content-video-provider': detail.videocontentprovider || '',
                //templatetype: detail.templatetype || '',
                //noinitialanalytics: false,
                'page-has-video': "yes"
                //videoFulllengthUrl: detail.videoFulllengthUrl || '',
                //milestonetrack: detail.milestonetrack || '',
                //videotranscript: detail.videotranscript || '',
                //videoOrigin: detail.videoOrigin || ''
            }));
            FwInfo.setsessionvalue('prevpath', document.location.pathname);
        },

        _getHashValue: function() {
            return location.hash.match(this.hashRegExp) && RegExp.$1;
        },
        _getCspValue: function() {
            return window.location.search.match(this.cspRegExp) && RegExp.$1;
        },
        _getCstList: function(cst) {
            return cst.replace(/\/\/*$/,'').split('/');
        },
        _getSstsList: function(ssts) {
            return ssts ? ssts.split('/') : [];
        },
        _getDayOfWeek: function() {
            return this.daysArr[new Date().getDay()];
        },
        _getTimeOfDay: function() {
            var halfHour = new Date(1800000 * parseInt(new Date().getTime() / 1800000, 10)),
                h = halfHour.getHours();
            return (1 + (h + 11) % 12) + ':' + (function(h) {
                    return h.substr(h.length - 2);
                })('0' + halfHour.getMinutes()) + ( h > 11 ? ' pm' :' am');
        },
        _getOembedData: function(js_modules, assetid) {
            var oembedCount = 0,
                oembedString = '';
            if (typeof js_modules !== 'undefined') {
                for (var i = 0; i < js_modules.length; i++) {
                    var jsModule = js_modules[i];
                    if (jsModule.oembedprovider) {
                        oembedCount++;
                        oembedString += '|' + oembedCount + ',' + jsModule.oembedprovider + ',' + assetid;
                    }
                }
                if (oembedCount) {
                    return oembedCount + oembedString;
                }
            }
        }

    };

    var _setDataLayer = new SetDataLayer();
    return _setDataLayer;
});

